import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, resolveDirective as _resolveDirective, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container my-4" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_3 = { class: "mb-0" }
const _hoisted_4 = { class: "d-flex gap-2" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "row g-2 align-items-center mb-3" }
const _hoisted_7 = { class: "col-md" }
const _hoisted_8 = { class: "col-md-auto" }
const _hoisted_9 = { class: "form-check" }
const _hoisted_10 = { class: "table table-bordered table-striped align-middle" }
const _hoisted_11 = {
  key: 0,
  style: {"width":"42px"}
}
const _hoisted_12 = ["checked", ".indeterminate"]
const _hoisted_13 = {
  key: 0,
  class: "text-center"
}
const _hoisted_14 = ["value"]
const _hoisted_15 = {
  key: 0,
  class: "badge text-bg-secondary ms-2"
}
const _hoisted_16 = {
  key: 0,
  class: "badge text-bg-primary me-1"
}
const _hoisted_17 = {
  key: 1,
  class: "badge text-bg-info"
}
const _hoisted_18 = { class: "btn-group d-flex flex-wrap gap-1" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = ["colspan"]
const _hoisted_21 = {
  key: 0,
  class: "modal modal-custom fade show",
  style: {"display":"block"},
  tabindex: "-1",
  "aria-modal": "true",
  role: "dialog"
}
const _hoisted_22 = { class: "modal-dialog" }
const _hoisted_23 = { class: "modal-content" }
const _hoisted_24 = { class: "modal-header" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { class: "modal-body" }
const _hoisted_27 = { class: "alert alert-info py-2" }
const _hoisted_28 = { class: "mb-3" }
const _hoisted_29 = { class: "mb-3" }
const _hoisted_30 = ["value"]
const _hoisted_31 = {
  key: 0,
  class: "form-text"
}
const _hoisted_32 = { class: "mb-3" }
const _hoisted_33 = { class: "mb-1" }
const _hoisted_34 = { class: "form-text" }
const _hoisted_35 = { class: "modal-footer" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = ["disabled"]
const _hoisted_38 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_39 = {
  key: 1,
  class: "modal-backdrop-custom fade show"
}

import { ref, onMounted, computed, watch, nextTick } from "vue";
import { useRoute } from "vue-router";
import api from "@/api";
import { showAlert } from "@/utils/dialogs";

interface Cliente {
  _id?: string;
  razon_social?: string | null;
  nombre?: string;
  nombre_display?: string;
  nombres: string | null;
  apellido: string | null;
  dni: string | null;
  cuit_cuil: string;
  nro_iibb: string | null;
  saldo: number;
  situacion_iva: string | null;
  direccion: string | null;
  localidad: string | null;
  telefono1: string | null;
  telefono2: string | null;
  email: string | null;
  grupo: string | null;
  lista_precio_id?: string;
  lista_precio_nombre?: string;
  activo?: boolean;
  es_cliente?: boolean;
  es_proveedor?: boolean;
}

interface MovimientoTipo {
  _id: string;
  nombre: string;
  signo: "debe" | "haber";
  interes_punitorio?: number;
  vencimiento_dias?: number;
  descripcion?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Clientes',
  setup(__props) {

const clientes = ref<Cliente[]>([]);
const route = useRoute();
const esListadoProveedores = computed(() => route.path === "/proveedores");
const tipoListado = computed(() => esListadoProveedores.value ? "proveedor" : "cliente");
const nombreTipoPlural = computed(() => esListadoProveedores.value ? "Proveedores" : "Clientes");
const nombreTipoSingular = computed(() => esListadoProveedores.value ? "proveedor" : "cliente");
const contextoEdicionQuery = computed(() => esListadoProveedores.value ? { tipo: "proveedor" } : {});
const rutaNuevaPersona = computed(() => ({
  path: "/clientes/nuevo",
  query: contextoEdicionQuery.value,
}));
const busqueda = ref("");
const soloActivos = ref(true);

/** ───── Movimiento masivo state ───── */
const massMode = ref(false);
const selectedIds = ref<string[]>([]);
const showModal = ref(false);
const submitting = ref(false);

const tiposMovimiento = ref<MovimientoTipo[]>([]);
const tipoSeleccionado = computed(
  () => tiposMovimiento.value.find((t) => t._id === form.value.tipo_id) || null
);

const today = () => new Date().toISOString().slice(0, 10);
const form = ref({
  fecha: today(),
  tipo_id: "",
  detalle: "",
  importe: "" as string | number,
});

const nombreCliente = (cliente: Cliente) =>
  cliente.nombre_display ||
  cliente.nombre ||
  cliente.razon_social ||
  [cliente.apellido, cliente.nombres].filter(Boolean).join(" ").trim() ||
  "Sin nombre";

/** ───── Filtros y tabla ───── */
const clientesFiltrados = computed(() => {
  const list = !busqueda.value
    ? clientes.value
    : clientes.value.filter((c) =>
        [c.razon_social, c.nombres, c.apellido, c.cuit_cuil, c.dni, nombreCliente(c)].some((campo: any) =>
          (campo || "").toLowerCase().includes(busqueda.value.toLowerCase())
        )
      );
  return list.sort((a, b) => {
    const nombreA = nombreCliente(a).toLowerCase();
    const nombreB = nombreCliente(b).toLowerCase();
    return nombreA.localeCompare(nombreB);
  });
});

const todosSeleccionados = computed(
  () =>
    clientesFiltrados.value.length > 0 &&
    selectedIds.value.length === clientesFiltrados.value.length
);
const indeterminado = computed(
  () =>
    selectedIds.value.length > 0 &&
    selectedIds.value.length < clientesFiltrados.value.length
);

function toggleSeleccionTodos(e: Event) {
  const checked = (e.target as HTMLInputElement).checked;
  selectedIds.value = checked ? clientesFiltrados.value.map((c) => c._id!) : [];
}

function toggleMassMode() {
  massMode.value = !massMode.value;
  if (!massMode.value) selectedIds.value = [];
}

async function abrirModalMasivo() {
  if (selectedIds.value.length === 0) {
    await showAlert(`Seleccioná al menos un ${nombreTipoSingular.value}.`, {
      title: nombreTipoPlural.value,
      variant: "warning",
    });
    return;
  }
  // cargar tipos si hace falta
  if (!tiposMovimiento.value.length) {
    await cargarTiposMovimiento();
  }
  // preseleccionar primer tipo
  if (tiposMovimiento.value.length && !form.value.tipo_id) {
    form.value.tipo_id = tiposMovimiento.value[0]._id;
    onTipoChange();
  }
  showModal.value = true;
  await nextTick();
  setTimeout(() => {
    const el = document.getElementById(
      "importe-masivo"
    ) as HTMLInputElement | null;
    el?.focus();
  }, 30);
}

function cerrarModal() {
  if (submitting.value) return;
  showModal.value = false;
  // mantenemos selección para repetir con el mismo set si se desea
}

const formValido = computed(() => {
  const n = Number(form.value.importe);
  return (
    !!form.value.fecha &&
    !!form.value.tipo_id &&
    form.value.detalle.trim().length >= 3 &&
    !isNaN(n) &&
    n > 0
  );
});

function onTipoChange() {
  const t = tipoSeleccionado.value;
  if (t && !form.value.detalle.trim()) {
    form.value.detalle = t.nombre;
  }
}

/** ───── API calls ───── */
const cargarClientes = async () => {
  try {
    const res = await api.get<Cliente[]>("/clientes", {
      params: { activos: soloActivos.value, tipo: tipoListado.value },
    });
    clientes.value = res.data.sort((a, b) => {
      const nombreA = nombreCliente(a).toLowerCase();
      const nombreB = nombreCliente(b).toLowerCase();
      return nombreA.localeCompare(nombreB);
    });
    selectedIds.value = selectedIds.value.filter((id) =>
      clientes.value.some((cliente) => cliente._id === id)
    );
  } catch (error) {
    console.error("Error cargando clientes:", error);
  }
};

const cargarTiposMovimiento = async () => {
  try {
    const { data } = await api.get<MovimientoTipo[]>("/movimiento-tipos");
    tiposMovimiento.value = data;
  } catch (e) {
    console.error("Error cargando tipos de movimiento:", e);
  }
};

const confirmarMovimientoMasivo = async () => {
  if (!formValido.value || !tipoSeleccionado.value) return;
  try {
    submitting.value = true;
    const payload = {
      cliente_ids: selectedIds.value,
      descripcion: form.value.detalle.trim(),
      importe: Number(form.value.importe),
      tipo_id: tipoSeleccionado.value._id,
      tipo: tipoSeleccionado.value.nombre,
      fecha: form.value.fecha,
    };
    const { data } = await api.post(
      "/cuenta_corriente/movimientos/masivo",
      payload
    );
    await showAlert(
      `Se insertaron ${data.insertados} movimientos (${data.signo}) por ${data.importe}.`,
      {
        title: nombreTipoPlural.value,
        variant: "success",
      }
    );
    showModal.value = false;
    massMode.value = false;
    selectedIds.value = [];
    form.value = { fecha: today(), tipo_id: "", detalle: "", importe: "" };
  } catch (e: any) {
    const msg =
      e?.response?.data?.detail ||
      e.message ||
      "No se pudo generar el movimiento masivo";
    await showAlert(msg, {
      title: nombreTipoPlural.value,
      variant: "danger",
    });
    console.error(e);
  } finally {
    submitting.value = false;
  }
};

/** ───── Utils ───── */
const formatearMoneda = (valor: number) =>
  valor.toLocaleString("es-AR", { style: "currency", currency: "ARS" });

/** ───── Body scroll lock para el modal ───── */
watch(showModal, (val) => {
  const cls = "modal-open";
  if (val) document.body.classList.add(cls);
  else document.body.classList.remove(cls);
});

/** ───── Lifecycle ───── */
onMounted(() => {
  cargarClientes();
  cargarTiposMovimiento();
});

watch(tipoListado, () => {
  selectedIds.value = [];
  massMode.value = false;
  cargarClientes();
});

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_importe = _resolveDirective("importe")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, "Gestión de " + _toDisplayString(nombreTipoPlural.value), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: _normalizeClass(["btn", massMode.value ? 'btn-outline-secondary' : 'btn-outline-primary']),
          onClick: toggleMassMode
        }, _toDisplayString(massMode.value ? "Cancelar" : "Movimiento masivo"), 3),
        (massMode.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-primary",
              disabled: selectedIds.value.length === 0,
              onClick: abrirModalMasivo
            }, " Generar movimiento (" + _toDisplayString(selectedIds.value.length) + ") ", 9, _hoisted_5))
          : _createCommentVNode("", true),
        _createVNode(_component_router_link, {
          to: rutaNuevaPersona.value,
          class: "btn btn-success ms-1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_FontAwesomeIcon, { icon: "plus" }),
            _cache[7] || (_cache[7] = _createTextVNode(" Nuevo "))
          ]),
          _: 1,
          __: [7]
        }, 8, ["to"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((busqueda).value = $event)),
          class: "form-control",
          placeholder: "Buscar por razón social, nombre, apellido, CUIT o DNI..."
        }, null, 512), [
          [_vModelText, busqueda.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("input", {
            id: "solo-activos",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((soloActivos).value = $event)),
            class: "form-check-input",
            type: "checkbox",
            onChange: cargarClientes
          }, null, 544), [
            [_vModelCheckbox, soloActivos.value]
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("label", {
            class: "form-check-label",
            for: "solo-activos"
          }, "Activos", -1))
        ])
      ])
    ]),
    _createElementVNode("table", _hoisted_10, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          (massMode.value)
            ? (_openBlock(), _createElementBlock("th", _hoisted_11, [
                _createElementVNode("input", {
                  type: "checkbox",
                  class: "form-check-input",
                  checked: todosSeleccionados.value,
                  ".indeterminate": indeterminado.value,
                  onChange: toggleSeleccionTodos,
                  title: "Seleccionar todos"
                }, null, 40, _hoisted_12)
              ]))
            : _createCommentVNode("", true),
          _cache[9] || (_cache[9] = _createElementVNode("th", null, "Nombre", -1)),
          _cache[10] || (_cache[10] = _createElementVNode("th", null, "Tipo", -1)),
          _cache[11] || (_cache[11] = _createElementVNode("th", null, "CUIT", -1)),
          _cache[12] || (_cache[12] = _createElementVNode("th", null, "Teléfono", -1)),
          _cache[13] || (_cache[13] = _createElementVNode("th", null, "Lista", -1)),
          _cache[14] || (_cache[14] = _createElementVNode("th", null, "Saldo", -1)),
          _cache[15] || (_cache[15] = _createElementVNode("th", null, "Acciones", -1))
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clientesFiltrados.value, (c) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: c._id
          }, [
            (massMode.value)
              ? (_openBlock(), _createElementBlock("td", _hoisted_13, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    class: "form-check-input",
                    value: c._id,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedIds).value = $event))
                  }, null, 8, _hoisted_14), [
                    [_vModelCheckbox, selectedIds.value]
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("td", null, [
              _createTextVNode(_toDisplayString(nombreCliente(c)) + " ", 1),
              (c.activo === false)
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, " Inactivo "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", null, [
              (c.es_cliente !== false)
                ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Cliente"))
                : _createCommentVNode("", true),
              (c.es_proveedor !== false)
                ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Proveedor"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", null, _toDisplayString(c.cuit_cuil), 1),
            _createElementVNode("td", null, _toDisplayString(c.telefono1), 1),
            _createElementVNode("td", null, _toDisplayString(c.lista_precio_nombre || "—"), 1),
            _createElementVNode("td", null, _toDisplayString(formatearMoneda(c.saldo || 0)), 1),
            _createElementVNode("td", null, [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_router_link, {
                  to: { path: `/clientes/${c._id}/editar`, query: contextoEdicionQuery.value },
                  class: "btn btn-sm btn-outline-primary"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_FontAwesomeIcon, { icon: "pen-to-square" }),
                    _cache[16] || (_cache[16] = _createTextVNode(" Editar "))
                  ]),
                  _: 2,
                  __: [16]
                }, 1032, ["to"])
              ])
            ])
          ]))
        }), 128)),
        (clientesFiltrados.value.length === 0)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
              _createElementVNode("td", {
                colspan: massMode.value ? 8 : 7,
                class: "text-center"
              }, " No se encontraron " + _toDisplayString(nombreTipoPlural.value.toLowerCase()) + ". ", 9, _hoisted_20)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (showModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("form", {
                onSubmit: _withModifiers(confirmarMovimientoMasivo, ["prevent"])
              }, [
                _createElementVNode("div", _hoisted_24, [
                  _cache[17] || (_cache[17] = _createElementVNode("h5", { class: "modal-title" }, "Generar movimiento masivo", -1)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-close",
                    onClick: cerrarModal,
                    disabled: submitting.value
                  }, null, 8, _hoisted_25)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _cache[18] || (_cache[18] = _createTextVNode(" Se aplicará a ")),
                    _createElementVNode("strong", null, _toDisplayString(selectedIds.value.length), 1),
                    _createTextVNode(" " + _toDisplayString(nombreTipoPlural.value.toLowerCase()) + ". ", 1)
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _cache[19] || (_cache[19] = _createElementVNode("label", { class: "form-label" }, "Fecha", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.fecha) = $event)),
                      type: "date",
                      class: "form-control",
                      required: ""
                    }, null, 512), [
                      [_vModelText, form.value.fecha]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _cache[21] || (_cache[21] = _createElementVNode("label", { class: "form-label" }, "Tipo", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.tipo_id) = $event)),
                      class: "form-select",
                      required: "",
                      onChange: onTipoChange
                    }, [
                      _cache[20] || (_cache[20] = _createElementVNode("option", {
                        disabled: "",
                        value: ""
                      }, "Seleccionar tipo", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tiposMovimiento.value, (t) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: t._id,
                          value: t._id
                        }, _toDisplayString(t.nombre) + " (" + _toDisplayString(t.signo) + ") ", 9, _hoisted_30))
                      }), 128))
                    ], 544), [
                      [_vModelSelect, form.value.tipo_id]
                    ]),
                    (tipoSeleccionado.value?.descripcion)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(tipoSeleccionado.value.descripcion), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _cache[22] || (_cache[22] = _createElementVNode("label", { class: "form-label" }, "Detalle", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.detalle) = $event)),
                      type: "text",
                      class: "form-control",
                      minlength: "3",
                      required: "",
                      placeholder: "Ej: Mantenimiento mensual"
                    }, null, 512), [
                      [
                        _vModelText,
                        form.value.detalle,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _cache[23] || (_cache[23] = _createElementVNode("label", { class: "form-label" }, "Importe", -1)),
                    _withDirectives(_createElementVNode("input", {
                      id: "importe-masivo",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.importe) = $event)),
                      type: "number",
                      step: "0.01",
                      min: "0.01",
                      class: "form-control",
                      required: "",
                      placeholder: "0,00"
                    }, null, 512), [
                      [_vModelText, form.value.importe],
                      [_directive_importe]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _cache[24] || (_cache[24] = _createTextVNode(" Signo: ")),
                    _createElementVNode("strong", null, _toDisplayString(tipoSeleccionado.value?.signo || "-"), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-secondary",
                    onClick: cerrarModal,
                    disabled: submitting.value
                  }, " Cancelar ", 8, _hoisted_36),
                  _createElementVNode("button", {
                    type: "submit",
                    class: "btn btn-primary",
                    disabled: !formValido.value || submitting.value
                  }, [
                    (submitting.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_38))
                      : _createCommentVNode("", true),
                    _cache[25] || (_cache[25] = _createTextVNode(" Confirmar "))
                  ], 8, _hoisted_37)
                ])
              ], 32)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (showModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_39))
      : _createCommentVNode("", true)
  ]))
}
}

})